const sharePopup = document.querySelector('.share__popup');
const shareContent = document.querySelector('.share__popup-content');
const shareBtn = document.querySelector('.share__btn');
const closeBtn = document.querySelector('.share__popup-close');
const copyBtn = document.querySelector('.share__popup-clipboard-btn');
const linkText = document.querySelector('.share__popup-clipboard-link');

const url = window.location.protocol + "//" + window.location.host + window.location.pathname;

linkText.textContent = url;

closeBtn.addEventListener('click', () => {
  sharePopup.classList.remove('share__popup-show');
})

sharePopup.addEventListener('click', (e) => {
  if(!shareContent.contains(e.target)) {
    sharePopup.classList.remove('share__popup-show');
  }
});

copyBtn.addEventListener('click', () => {
  window.navigator.clipboard.writeText(url);
})

shareBtn.addEventListener('click', async () => {
  if(window.innerWidth <= 768 && navigator.share) {
    try {
      await navigator.share({
        url
      });
    } catch (err) {
      console.log(err)
    }
  } else {
    sharePopup.classList.add('share__popup-show');
  }
})